import { useGetServicesQuery } from '../../__generated__/chirp/com/hubspot/service/catalog/rpc/ServiceCatalogServiceRpc.hooks';
export function useGetCatalogServices({
  skip
}) {
  const {
    data,
    loading
  } = useGetServicesQuery({
    variables: {},
    skip
  });
  return {
    catalogServices: data === null || data === void 0 ? void 0 : data.services,
    loading
  };
}